import { Skeleton } from '@/components/ui/skeleton';

export function SiteCardSkeleton() {
  return (
    <div className="rounded-lg border border-border bg-bg-surface p-5 space-y-3">
      <Skeleton className="h-5 w-1/2" />
      <Skeleton className="h-3 w-2/3" />
      <Skeleton className="h-10 w-full" />
    </div>
  );
}
